import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class ObBasvuruTuruListeAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "ObBasvuruTuruListe";
        super(baseUrl);
    }

    getObBasvuruTuruListeListe() {
        return this.get("");

    }
}
export default new ObBasvuruTuruListeAPI();